import { SxProps, Theme } from '@mui/material'

export const compactDatePickerLayoutSx: SxProps<Theme> = {
    '& .MuiDateCalendar-root': {
        width: 250,
        maxHeight: 260,
    },
    '& .MuiPickersDay-root': {
        width: 28,
        height: 28,
        fontSize: '0.75rem',
    },
    '& .MuiDayCalendar-weekDayLabel': {
        width: 28,
        height: 28,
        fontSize: '0.7rem',
    },
}
